import formatUserAnswer from '../../../../helpers/formatUserAnswer';
import formatDisplayDateWithFormat from 'syf-js-utilities/formats/formatDisplayDateWithFormat';
import { Analytics } from '../../../../helpers/analyticsMiddleware';
import { RECURRING_TABLE_LIST_QUESTION_ID } from '../../../../const/questionIds';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var focusRef = function (ref, formError) {
    var _a;
    if (formError) {
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
};
export var getQuestionAnalytics = function (questionId, hasDuplicateTransactions) {
    if (questionId === RECURRING_TABLE_LIST_QUESTION_ID) {
        return {
            pageKind: Analytics.Dispute,
            pageFunction: Analytics.Billing,
            pageSubFunction: Analytics.RecurringCharge,
            pageName: hasDuplicateTransactions
                ? Analytics.AdditionalTransactions
                : Analytics.NoTransactions
        };
    }
    return {
        pageKind: Analytics.Dispute,
        pageFunction: Analytics.Billing,
        pageSubFunction: questionId,
        pageName: Analytics.Questionnaire
    };
};
export var formatAndDispatchDateAnswer = function (date, currentQuestionAnswer, options, currentQuestion) {
    var _a, _b, _c, _d, _e;
    var nextQuestionId = (_a = options[0]) === null || _a === void 0 ? void 0 : _a.nextQuestionId;
    var answerId = (_b = options[0]) === null || _b === void 0 ? void 0 : _b.answerId;
    var disputeReason = (_c = options[0]) === null || _c === void 0 ? void 0 : _c.disputeReason;
    var script = (_d = options[0]) === null || _d === void 0 ? void 0 : _d.script;
    var hasAdditionalContent = (_e = options[0]) === null || _e === void 0 ? void 0 : _e.additionalContent;
    var additionalContent = currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers[1];
    var optionData = [formatDisplayDateWithFormat(date, 'MM/dd/yyyy')];
    if (hasAdditionalContent && additionalContent) {
        optionData.push(additionalContent);
    }
    return formatUserAnswer({
        nextQuestionId: nextQuestionId,
        answerId: answerId,
        option: optionData,
        currentQuestion: currentQuestion,
        disputeReason: disputeReason,
        script: script
    });
};
export var setDateToAnswer = function (answer, setDateHandler) {
    if (answer) {
        setDateHandler();
    }
};
//# sourceMappingURL=helpers.js.map